export const DEFAULT_PHONE_NUMBER = '1.888.80.RENTS';
